import { cn } from '@/lib/utils'
import type { PanelArtProps } from './panel-art-props'

/**
 * Price Action Graph panel art: one session walked minute by minute. A shaded
 * band marks the middle of the day, the jagged accent path climbs through it
 * and fades into the close, and two short ticks mark the open and the close
 * against a dotted prior close.
 */

const PATH =
  'M14 74 L22 68 L30 72 L38 60 L46 64 L54 50 L62 54 L70 40 L78 44 L86 32 L94 38 L102 34 L110 44 L118 40 L126 50 L134 46 L142 54'

const PRIOR_CLOSE = 74

export function PriceActionArt({ className }: PanelArtProps) {
  return (
    <svg
      viewBox="0 0 160 100"
      preserveAspectRatio="xMidYMid meet"
      aria-hidden="true"
      focusable="false"
      className={cn('h-full w-full', className)}
    >
      {/* Mid session band, behind everything. */}
      <rect x={57} y={12} width={46} height={76} rx={2} fill="hsl(var(--foreground) / 0.06)" />
      <path d={`${PATH} L142 88 L14 88 Z`} fill="hsl(var(--primary) / 0.14)" stroke="none" />
      <path
        d={`M12 ${PRIOR_CLOSE} H148`}
        fill="none"
        stroke="hsl(var(--muted-foreground) / 0.35)"
        strokeWidth="1.5"
        strokeDasharray="3 4"
        vectorEffect="non-scaling-stroke"
      />
      <path
        d={PATH}
        fill="none"
        stroke="hsl(var(--primary))"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        vectorEffect="non-scaling-stroke"
      />
      {/* Open tick, then close tick. */}
      <path
        d="M12 74 H24 M134 54 H148"
        fill="none"
        stroke="hsl(var(--foreground) / 0.5)"
        strokeWidth="2.5"
        strokeLinecap="round"
        vectorEffect="non-scaling-stroke"
      />
    </svg>
  )
}
